import { createFileRoute } from '@tanstack/react-router';

// Splat route: catches all sub-paths under /n/feature-requests/* so Canny's own
// navigation resolves.
// Renders nothing: the widget lives on the parent route (see n._auth.feature-requests.tsx)
export const Route = createFileRoute('/n/_auth/feature-requests/$')({});
